export default __webpack_public_path__ + "static/media/mockitup.53c2c0c7.png";